import EducationQualificationCodebookContainer from '@src/components/codebook/EducationQualificationCodebookContainer';
import React from 'react';

const AdminEducationQualificationCodebookPage = () => <EducationQualificationCodebookContainer />;

export default AdminEducationQualificationCodebookPage;
